// Copyright (c) 2026 Isolated Networks. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use
// of this file, via any medium, is strictly prohibited.
// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { MqttActivityProvider } from './context/MqttActivityContext';
import CssBaseline from '@mui/material/CssBaseline';

// Silence console.log and console.debug in production to reduce noise and prevent info leakage.
// console.warn and console.error are preserved for operational visibility.
if (process.env.NODE_ENV !== 'development') {
  console.log = () => {};
  console.debug = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CssBaseline />
      <AuthProvider>
        <MqttActivityProvider>
          <App />
        </MqttActivityProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
